/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef } from "react";
import { InfoFormDefault, TimesIcon } from "~misc/icons";
import { Field, Form, Formik } from "formik";
import { Checkbox, FormControl, FormLabel, Input } from "@chakra-ui/react";
import Select from "~components/Form/components/Select";
import "../../styles.scss";
import useSimulatorsCreateProductForm from "../../hooks/useSimulatorsCreateProductForm";
import { useState } from "react";
import useModalPrice from "~components/Modal/hooks/useModalPrice";
import ModalCreateProduct from "../modals/ModalCreateProduct";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useGrupoProduto from "~/fetchs/useGrupoProduto";
import useProduto from "~/fetchs/useProduto";
import { useNavigate, useParams } from "react-router-dom";
import useFamiliaProduto from "~/fetchs/useFamiliaProduto";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import PercentageInput from "~components/Form/components/PercentageInput";
import { initialPath } from "~misc/paths";
import useFilial from "~/fetchs/useFilial";
import useSimulators from "../../hooks/useSimulators";
import usePrazoPagamento from "~/fetchs/usePrazoPagamento";
import useCliente from "~/fetchs/useCliente";
import usePrecoRegra from "~/fetchs/usePrecoRegra";
import { getLocalStorage, removeLocalStorage, saveLocalStorage } from "~services/utils/SaveIndexBD";
import useCalculateDiscount from "~pages/Simulators/hooks/useCalculateDiscount";
import { money } from "~hooks/useHelpers";
import CurrencyInputAlternate from "~components/Form/components/CurrencyInputAlternate";
import { Spinner } from "@chakra-ui/react";
import useProdutoFilialPrecoRegraMicrorregiao from "~/fetchs/useProdutoFilialPrecoRegraMicrorregiao";
import Multiselect from "multiselect-react-dropdown";
import PercentageSpc from "~components/Form/components/PercentageSpc";
import ModalResponse from "~components/Modal/ModalResponse";
import useSubGrupoMaterial from "~/fetchs/useSubGrupoMaterial";
import useTipoCondicao from "~/fetchs/useTipoCondicao";

const NoInfoOverlay = ({ name, setShowOverlay }) => {
  const overlayRef = useRef(null);

  const handleClick = () => {
    setShowOverlay((prev) => ({
      ...prev,
      [name]: false,
    }));

    overlayRef.current?.parentElement.children[0].getElementsByTagName("input")[0].focus();
  };

  return (
    <div className="absolute w-full top-0 bg-[#E6E6E6]" ref={overlayRef}>
      <Input onClick={handleClick} className="text-center" style={{ fontSize: 14 }} readOnly />
    </div>
  );
};

const ProductSelectionSection = ({
  optionFiliaisE, onChangeFilial, filialSelectE,
  optionGruposProduto, onChangeGrupoProduto, grupoProdutoSelect,
  optionProdutos, onChangeProduto, produtoSelect,
  errors, touched
}) => (
  <FormControl className="flex container gap-x-6 pt-6">
    <div className=" w-[100%]">
      <FormLabel className="select-label">Centro/Filial:</FormLabel>
      <Select
        name="filialId"
        placeholder=""
        options={optionFiliaisE}
        noOptionsMessage="Centro/Filial não encontrado"
        onChange={onChangeFilial}
        errors={errors?.filialId}
        touched={touched?.filialId}
        isDisabled
        {...filialSelectE}
      />
    </div>

    <div className=" w-[100%]">
      <FormLabel className="select-label">Grupo de Produto:</FormLabel>
      <Select
        name="grupoProduto"
        label=""
        placeholder="Buscar Grupo Produto"
        options={optionGruposProduto}
        noOptionsMessage="Grupo de produto não encontrado"
        onChange={onChangeGrupoProduto}
        errors={errors.grupoProduto}
        touched={touched.grupoProduto}
        setFieldValue={() => {}}
        isDisabled
        {...grupoProdutoSelect}
      />
    </div>
    <div className=" w-[100%]">
      <FormLabel className="select-label">Produto:</FormLabel>
      <Select
        name="produto"
        label=""
        placeholder="Buscar Produto"
        options={optionProdutos}
        noOptionsMessage="Grupo de produto não encontrado"
        onChange={onChangeProduto}
        errors={errors.produto}
        touched={touched.produto}
        setFieldValue={() => {}}
        isDisabled
        {...produtoSelect}
      />
    </div>
  </FormControl>
);

const ProposalTypeSection = ({
  manterRegra, faixa, condicaoEspecial,
  clickProposta, errors, touched
}) => (
  <div className="containerForm container bg-white p-7 rounded-lg mt-4 relative">
    <div className="sm:flex justify-between py-3">
      <h2 className="text-2xl font-bold title pb-6">Tipo de Proposta</h2>
    </div>
    <div className="sm:flex sm:justify-between sm:items-center concorrente proposta gap-x-4 mt-4">
      <div className="sm:w-1/3 flex items-center gap-x-2">
        <label className="flex items-center space-x-2">
          <Field
            type="checkbox"
            name="condicao.manter"
            onClick={() => clickProposta("manter")}
            checked={manterRegra}
          />
        </label>
        <span className="text-lg font-bold">
          Manter <br /> no preço regra
        </span>
      </div>
      <div className="sm:w-1/3 mt-4 sm:mt-0 flex items-center gap-x-2">
        <label className="flex items-center space-x-2">
          <Field
            type="checkbox"
            name="condicao.faixa"
            onClick={() => clickProposta("faixa")}
            checked={faixa}
          />
        </label>
        <span className="text-lg font-bold">Faixa</span>
        <InfoFormDefault />
      </div>

      <div className="sm:w-1/3 mt-4 sm:mt-0 flex items-center gap-x-2">
        <label className="flex items-center space-x-2">
          <Field
            type="checkbox"
            name="condicao.especial"
            onClick={() => clickProposta("especial")}
            checked={condicaoEspecial}
          />
        </label>
        <span className=" text-lg font-bold">
          Condição Especial <br /> de Preço e Prazo
        </span>
        <InfoFormDefault />
      </div>
    </div>
    {errors.condicao && touched.condicao && <p style={{ color: "red", fontSize: "14px" }}>{errors.condicao}</p>}
  </div>
);

const NegotiationTableRow = ({ label, children, colSpan }) => (
  <tr className="bg-row2">
    <td className="p-2 sm:p-4 w-1/3">{label}</td>
    {colSpan ? (
      <td className="p-2 sm:p-4" colSpan={colSpan}>{children}</td>
    ) : (
      <>
        <td className="p-2 sm:p-4 w-1/3">{children?.[0]}</td>
        <td className="p-2 sm:p-4 w-1/3">{children?.[1]}</td>
      </>
    )}
  </tr>
);

const PriceCell = ({
  type, precoFinal, setPrecoFinal, desconto, setDesconto,
  showOverlay, setShowOverlay, condicaoEspecial,
  setIsEditingDesconto, setIsEditingPrecoFinal
}) => {
  const handleClearPrice = () => {
    setPrecoFinal(0);
    setDesconto(-100);
    setShowOverlay(prev => ({ ...prev, [type]: true }));
  };

  return (
    <td className="p-2 sm:p-4 w-1/3">
      <div className="relative">
        <CurrencyInputAlternate
          type="text"
          inputName={`precoFinal${type.toUpperCase()}`}
          input={precoFinal}
          setInput={setPrecoFinal}
          center={true}
          readOnly={!condicaoEspecial}
          onFocus={() => {
            setIsEditingDesconto(false);
            setIsEditingPrecoFinal(true);
          }}
          onBlur={() => {
            setIsEditingPrecoFinal(false);
          }}
        />

        {!showOverlay[type] && precoFinal !== 0 && (
          <div
            onClick={handleClearPrice}
            className="absolute cursor-pointer right-0 top-0 h-full flex justify-center items-center z-[1]"
          >
            <TimesIcon fill="#000" />
          </div>
        )}

        {showOverlay[type] && <NoInfoOverlay name={type} setShowOverlay={setShowOverlay} />}
      </div>
    </td>
  );
};

const EditarProdutoFormulario = () => {
  const navigate = useNavigate();
  const formikRef = useRef();
  const { parameter: idCliente } = useParams();
  const { cliente } = useCliente(idCliente);

  const [loading, setLoading] = useState(false);
  const [isOpenModalResponse, setIsOpenModalResponse] = useState(false);
  const [microrregiaoId, setMicrorregiaoId] = useState(cliente?.microrregiaoId);
  const [clusterId, setClusterId] = useState(cliente?.clusterId);
  const [filialId, setFilialId] = useState(null);
  const [showOverlay, setShowOverlay] = useState({ fob: false, cif: false });
  const [manterRegra, setManterRegra] = useState(true);
  const [faixa, setFaixa] = useState(false);
  const [condicaoEspecial, setCondicaoEspecial] = useState(false);
  const [produtoReplicacao, setProdutoReplicacao] = useState("");
  const [filiaisReplicacao, setFiliaisReplicacao] = useState("");

  const { validationSchema, initialValues } = useSimulatorsCreateProductForm();
  const { isModalOpenPrice, closeModalPrice } = useModalPrice();
  const { tipoCondicoes } = useTipoCondicao(null);

  const normalizeText = (value = "") =>
    value
      .normalize("NFD")
      .replaceAll(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  const getTipoCondicaoIdByProposta = (proposta) => {
    const aliasesByProposta = {
      manter: ["manter no regra", "manter no preco regra"],
      faixa: ["faixa"],
      especial: ["condicao especial"],
    };

    const aliases = aliasesByProposta[proposta] || [];
    const tipo = (tipoCondicoes || []).find((item) => {
      if (item?.ativo === false) return false;
      const nome = normalizeText(item?.nome || "");
      return aliases.includes(nome);
    });

    return tipo?.id ?? null;
  };

  const getPropostaByCondicao = (condicao) => {
    if (condicao && typeof condicao === "object") {
      if (condicao.manter) return "manter";
      if (condicao.faixa) return "faixa";
      if (condicao.especial) return "especial";
      return null;
    }

    const condicaoNome = normalizeText(condicao || "");

    if (["manter no regra", "manter no preco regra", "preco regra"].includes(condicaoNome)) return "manter";
    if (condicaoNome === "faixa") return "faixa";
    if (condicaoNome === "condicao especial") return "especial";

    return null;
  };

  const getPropostaByTipoCondicaoId = (tipoCondicaoId) => {
    const tipo = (tipoCondicoes || []).find((item) => item?.id == tipoCondicaoId);
    if (!tipo) return null;

    return getPropostaByCondicao(tipo.nome);
  };

  const getPropostaFromSimulacao = (simulacao) => {
    return (
      getPropostaByTipoCondicaoId(simulacao?.tipoCondicaoId) ||
      getPropostaByCondicao(simulacao?.condicao) ||
      "manter"
    );
  };

  const { precosRegraDisponiveis, filiaisDisponiveis, gruposMateriaisDisponiveis, familiasDisponiveis, produtosDisponiveis } =
    useProdutoFilialPrecoRegraMicrorregiao({ microrregiaoId });

  // Hooks principais
  const {
    gruposProduto,
    optionGruposProduto,
    grupoProdutoSelect,
    onChangeGrupoProduto,
    grupoProduto,
    SetSelectGrupoProduto,
  } = useGrupoProduto({ formikRef, camposOpt: ["nome"] });

  const {
    produtos,
    produto: produtoSelecionado,
    optionProdutos,
    produtoSelect,
    onChangeProduto,
    SetSelectProduto,
    getIndexDBProdutoSimulacao,
    produtoSimulacao,
  } = useProduto({ grupoProduto, formikRef, name: "produtoId", camposOpt: ["descricaoProduto"] });

  const { filiais: filiaisE, optionFiliais:optionFiliaisE, onChangeFilial, filialSelect:filialSelectE, SetSelectFilial:SetSelectFilialE } =
    useFilial({ formikRef, filiaisDisponiveis });

  const { precoRegra } = usePrecoRegra({
    produto: produtoSimulacao?.produtoId,
    filial: filialId,
    microrregiao: microrregiaoId,
    cluster: clusterId,
    setLoading,
  });

  const { filiais, optionFiliais, onChangeFilial: onChangeFilialReplicacao } =
    useFilial({ formikRef, filiaisDisponiveis });

  const {
    optionGruposProduto: optionGruposProdutoReplicacao,
    grupoProdutoSelect: grupoProdutoReplicacaoSelect,
    onChangeGrupoProduto: onChangeGrupoProdutoReplicacao,
    grupoProduto: grupoProdutoReplicacao,
  } = useGrupoProduto({
    formikRef,
    name: "grupoProdutoReplicacaoId",
    filiais,
    filial: filialId,
    gruposDisponiveis: gruposMateriaisDisponiveis,
    camposOpt: ["nome"],
    replicacao: true
  });

  const {
    familiaProduto: familiaProdutoReplicacao,
    familiasProduto: familiasProdutoReplicacao,
    optionFamiliasProduto,
    familiaProdutoSelect,
    onChangeFamiliaProduto
  } = useFamiliaProduto({
    formikRef,
    name: "familiaProdutoReplicacaoId",
    familiasDisponiveis,
    replicacao: true
  });

  const {
    subGrupoMaterial: subGrupoMaterialReplicacao,
    optionSubGrupoMateriais,
    subGrupoMaterialSelect,
    onChangeSubGrupoMaterial
  } = useSubGrupoMaterial({
    formikRef,
    filialForm: filialId,
    name: 'subGrupoMaterialReplicacaoId',
    gruposMateriaisDisponiveis,
    replicacao: true
  });

  const {
    produtos: produtosReplicacao,
    optionProdutos: optionReplicacaoProdutos,
    produtoSelect: produtoReplicacaoSelect,
    onChangeProduto: onChangeProdutoReplicacao,
  } = useProduto({
    filialForm: filialId,
    produtosDisponiveis,
    formikRef,
    type: 'geral',
    name: "produtoReplicacaoId",
    camposOpt: ["codigo", "descricaoProduto"],
    typeOptions: 'multi',
    replicacao: true
  });

  const { optionGruposCentralizadores, onChangeGrupoCentralizador, grupoCentralizadorSelect } =
    useGrupoCentralizador(formikRef, "grupoCentralizadorReplicacaoId");

  const { prazoPagamentos, onChangePrazoPagamento, setSelectPrazoPagamento, prazoPagamentoSelect, optionPrazosPagamento } =
    usePrazoPagamento(formikRef);

  const { simulacaoProduto, desfetchProdutosEditSimulacao } = useSimulators();

  const {
    descontoCif,
    setDescontoCif,
    descontoFob,
    setDescontoFob,
    precoFinalCif,
    setPrecoFinalCif,
    precoFinalFob,
    setPrecoFinalFob,
    precoRegraCif,
    setPrecoRegraCif,
    precoRegraFob,
    setPrecoRegraFob,
    calculateDiscountFaixa,
    setIsEditingDesconto,
    setIsEditingPrecoFinal
  } = useCalculateDiscount(faixa, condicaoEspecial);

  // Funções auxiliares
  const optionFiliaisReplicacao = useMemo(() => {
    return (optionFiliais || []).filter((optFilial) => {
      const precosProdutoCheck = (precosRegraDisponiveis || []).some(pp =>  pp.produtoId == produtoSelecionado && pp.filialId === optFilial.value);
      return (optFilial.value !== filialId && precosProdutoCheck);
    });
  }, [optionFiliais, precosRegraDisponiveis, produtoSelecionado]);

  const handleProdutoReplicacaoMulti = (e) => {
    const produtosIds = e?.map(pReplicacao => pReplicacao.value).join(',') || "";
    setProdutoReplicacao(produtosIds);
    onChangeProdutoReplicacao({ label: "Produtos Selecionados", value: produtosIds});
  };

  const handleFilialReplicacaoMulti = (e) => {
    const filiaisIds = e?.map(fReplicacao => fReplicacao.value).join(',') || "";
    setFiliaisReplicacao(filiaisIds);
    onChangeFilialReplicacao({ label: "Filiais Selecionadas", value: filiaisIds});
  };

  const handleChangeEnviaPrazo = (e, type = "cif") => {
    if (type === "cif") formikRef.current?.setFieldValue("prazoCif", e.target.checked);
    else if (type === 'fob') formikRef.current?.setFieldValue("prazoFob", e.target.checked);
  };

  const setInitialReplicacoes = (simulacao) => {
    if (simulacao.grupoMaterialReplicacaoId) {
      const grupoProdutoReplicaoOpt = (optionGruposProdutoReplicacao || []).find((opt) => opt.value == simulacao.grupoMaterialReplicacaoId);
      if (grupoProdutoReplicaoOpt) {
        onChangeGrupoProdutoReplicacao(grupoProdutoReplicaoOpt);
        formikRef.current?.setFieldValue("grupoProdutoReplicacaoBool", true);
      }
    }

    if (simulacao.familiaMaterialReplicacaoId) {
      const familiaProdutoReplicaoOpt = (optionSubGrupoMateriais || []).find((opt) => opt.value == simulacao.familiaMaterialReplicacaoId);
      if (familiaProdutoReplicaoOpt) {
        onChangeSubGrupoMaterial(familiaProdutoReplicaoOpt);
        formikRef.current?.setFieldValue("subGrupoMaterailReplicacaoBool", true);
      }
    }

    if (simulacao.produtoReplicacaoId) {
      setProdutoReplicacao(simulacao.produtoReplicacaoId);
      onChangeProdutoReplicacao({ label: "Produtos Selecionados", value: simulacao.produtoReplicacaoId});

      const produtosReplicacaoIds = simulacao.produtoReplicacaoId.split(',');
      const selectedOptions = [];
      produtosReplicacaoIds.forEach(produtoReplicacaoId => {
        const produtoReplicaoOpt = (optionReplicacaoProdutos || []).find((opt) => opt.value == produtoReplicacaoId);
        if (produtoReplicaoOpt) selectedOptions.push(produtoReplicaoOpt);
      });
      formikRef.current?.setFieldValue("produtos", selectedOptions);
      formikRef.current?.setFieldValue("produtoReplicacaoBool", true);
    }

    if (simulacao.grupoCentralizadorReplicacaoId) {
      const grupoCentralizadorReplicaoOpt = (optionGruposCentralizadores || []).find((opt) => opt.value == simulacao.grupoCentralizadorReplicacaoId);
      if (grupoCentralizadorReplicaoOpt) {
        onChangeGrupoCentralizador(grupoCentralizadorReplicaoOpt);
        formikRef.current?.setFieldValue("grupoCentralizadorReplicacaoBool", true);
      }
    }
  };

  const saveProductToStorage = (produto) => {
    const data = getLocalStorage("simulacao-" + idCliente, true);

    if (!data || Object.keys(data).length === 0) {
      const simulacao = {
        createdAt: Date.now(),
        clienteId: idCliente,
        fracionamento: false,
        descargaManual: false,
        simulador: "ENSACADOS",
        gruposProduto: [{
          grupoProdutoId: produto.grupoMaterialId,
          grupoProduto: produto.grupoProduto,
          produtos: [produto],
        }],
      };
      saveLocalStorage("simulacao-" + idCliente, simulacao, true);
      return;
    }

    const indexGP = (data.gruposProduto || []).findIndex((opt) => opt.grupoMaterialId == produto.grupoMaterialId);

    if (indexGP > -1) {
      const index = (data.gruposProduto[indexGP].produtos || []).findIndex(
        (opt) => opt.produtoId == produto.produtoId && opt.filialId == produto.filialId
      );

      if (index > -1) {
        produto = {
          ...produto,
          id: data.gruposProduto[indexGP].produtos[index].id,
          quantidade: data.gruposProduto[indexGP].produtos[index].quantidade,
        };
        data.gruposProduto[indexGP].produtos[index] = produto;
      } else {
        data.gruposProduto[indexGP].produtos.push(produto);
      }
    } else if (Array.isArray(data.gruposProduto)) {
      data.gruposProduto.push({
        grupoProdutoId: produto.grupoMaterialId,
        grupoProduto: produto.grupoProduto,
        produtos: [produto],
      });
    } else {
      data.gruposProduto = [{
        grupoProdutoId: produto.grupoMaterialId,
        grupoProduto: produto.grupoProduto,
        produtos: [produto],
      }];
    }

    saveLocalStorage("simulacao-" + idCliente, data, true);
  };

  const processaProduto = async (values, optProduto, filial, replicacao = false) => {
    const grupoProduto = (gruposProduto || []).find((opt) => opt.id == values.grupoProdutoId);
    const prazoPagamento = (prazoPagamentos || []).find((opt) => opt.id == values.prazoPagamentoId);
    const familia = (familiasProdutoReplicacao || []).find((opt) => opt.id == optProduto.familiaId);

    if ((!familia || !familia?.replicacaoAtiva) && replicacao) return;

    const produto = {
      condicao: manterRegra ? "Manter no Regra" : faixa ? "Faixa" : "Condição Especial",
      tipoCondicaoId: values.tipoCondicaoId ?? null,
      precoFinal: {
        fob: values.precoFinalFob,
        cif: values.precoFinalCif,
      },
      precoRegra: {
        fob: values.precoRegraFob,
        cif: values.precoRegraCif,
      },
      desconto: {
        fob: values.descontoFob,
        cif: values.descontoCif,
      },
      prazoPagamentoId: values.prazoPagamentoId ? values.prazoPagamentoId : null,
      prazoPagamento: prazoPagamento?.nome,
      enviaPrazoCif: values.prazoCif,
      enviaPrazoFob: values.prazoFob,
      grupoMaterialId: grupoProduto?.id,
      grupoProduto: grupoProduto?.nome,
      produtoId: values.produtoId,
      familiaId: optProduto.familiaId,
      produtoOriginal: optProduto,
      produto: optProduto?.descricaoProduto,
      codigo: optProduto?.codigo,
      filial: filial?.nome,
      filialId: filial?.id,
      enviadoAprovacao: !manterRegra ? false : true,
      grupoMaterialReplicacaoId: values.grupoProdutoReplicacaoBool ? (grupoProdutoReplicacaoSelect?.initValue || null) : null,
      subGrupoMaterialReplicacaoId: values.subGrupoMaterailReplicacaoBool ? (subGrupoMaterialSelect?.initValue || null) : null,
      produtoReplicacaoId:  values.produtoReplicacaoBool ? (produtoReplicacaoSelect?.initValue || null) : null,
      grupoCentralizadorReplicacaoId: values.grupoCentralizadorReplicacaoBool ? (grupoCentralizadorSelect?.initValue || null) : null,
    };

    saveProductToStorage(produto);
  };

  const getFilial = () => {
    let filial = (filiaisE || []).find((opt) => opt.id == produtoSimulacao.filialId);
    if (!filial) filial = (filiaisE || []).find((opt) => opt.id == simulacaoProduto.filialId);
    return filial;
  };

  const processaReplicacao = async (values) => {
    if (values.grupoProdutoReplicacaoBool && grupoProdutoReplicacao && precosRegraDisponiveis) {
      await precosRegraDisponiveis.forEach(async precoProdutoGrupo => {
        if (precoProdutoGrupo.filialId == filialId) {
          const optProdutoReplicacao = (produtosReplicacao || []).find((opt) => opt.id == precoProdutoGrupo.produtoId);
          const filial = (filiais || []).find((opt) => opt.id == precoProdutoGrupo.filialId);

          if (optProdutoReplicacao && optProdutoReplicacao.grupoMaterialId === grupoProdutoReplicacao && filial) {
            await processaProduto({
              ...values,
              precoFinalFob: calculateDiscountFaixa(precoProdutoGrupo.valorPrecoFOB, descontoFob),
              precoFinalCif: calculateDiscountFaixa(precoProdutoGrupo.valorPrecoCIF, descontoCif),
              precoRegraFob: precoProdutoGrupo.valorPrecoFOB,
              precoRegraCif: precoProdutoGrupo.valorPrecoCIF,
              produtoId: precoProdutoGrupo.produtoId,
              grupoProdutoId: optProdutoReplicacao.grupoMaterialId
            },
            optProdutoReplicacao,
            filial,
            true);
          }
        }
      });
    }

    if (values.subGrupoMaterailReplicacaoBool && subGrupoMaterialReplicacao && precosRegraDisponiveis) {
      await precosRegraDisponiveis.forEach(async precoProdutoFimilia => {
        if (precoProdutoFimilia.filialId == filialId) {
          const optProdutoReplicacao = (produtosReplicacao || []).find((opt) => opt.id == precoProdutoFimilia.produtoId);
          const filial = (filiais || []).find((opt) => opt.id == precoProdutoFimilia.filialId);

          if (optProdutoReplicacao && optProdutoReplicacao.subGrupoMaterialId === subGrupoMaterialReplicacao && filial) {
            await processaProduto({
              ...values,
              precoFinalFob: calculateDiscountFaixa(precoProdutoFimilia.valorPrecoFOB, descontoFob),
              precoFinalCif: calculateDiscountFaixa(precoProdutoFimilia.valorPrecoCIF, descontoCif),
              precoRegraFob: precoProdutoFimilia.valorPrecoFOB,
              precoRegraCif: precoProdutoFimilia.valorPrecoCIF,
              produtoId: precoProdutoFimilia.produtoId,
              grupoProdutoId: optProdutoReplicacao.grupoMaterialId
            },
            optProdutoReplicacao,
            filial,
            true);
          }
        }
      });
    }

    if (values.produtoReplicacaoBool && produtoReplicacao && precosRegraDisponiveis) {
      await precosRegraDisponiveis.forEach(async precoProdutoRepli => {
        let prodsReplicacao = produtoReplicacao.split(',');

        prodsReplicacao?.forEach(async pReplicacao => {
          const idProdutoReplica = parseInt(pReplicacao);
          const optProdutoReplicacao = (produtosReplicacao || []).find((opt) => opt.id == idProdutoReplica);
          const filial = (filiais || []).find((opt) => opt.id == precoProdutoRepli.filialId);

          if (optProdutoReplicacao && precoProdutoRepli.produtoId === idProdutoReplica && filial) {
            await processaProduto({
              ...values,
              precoFinalFob: calculateDiscountFaixa(precoProdutoRepli.valorPrecoFOB, descontoFob),
              precoFinalCif: calculateDiscountFaixa(precoProdutoRepli.valorPrecoCIF, descontoCif),
              precoRegraFob: precoProdutoRepli.valorPrecoFOB,
              precoRegraCif: precoProdutoRepli.valorPrecoCIF,
              produtoId: precoProdutoRepli.produtoId,
              grupoProdutoId: optProdutoReplicacao.grupoMaterialId
            },
            optProdutoReplicacao,
            filial,
            true);
          }
        });
      });
    }

    if (values.centroReplicacaoBool && filiaisReplicacao && precosRegraDisponiveis) {
      const filteredPrecosProdutos = precosRegraDisponiveis.filter(pp =>  {
        const centroReplicacao = filiaisReplicacao.split(',')?.map(fr => parseInt(fr));
        return pp.produtoId == produtoSelecionado && centroReplicacao.includes(pp.filialId);
      });

      await filteredPrecosProdutos.forEach(async precoCentroRepli => {
        let centroReplicacao = filiaisReplicacao.split(',');

        centroReplicacao?.forEach(async fReplicacao => {
          const idCentroReplica = parseInt(fReplicacao);
          const optProdutoReplicacao = (produtosReplicacao || []).find((opt) => opt.id == produtoSelecionado);
          const filial = (filiais || []).find((opt) => opt.id == idCentroReplica);

          if (optProdutoReplicacao && precoCentroRepli.filialId === idCentroReplica && filial) {
            await processaProduto({
              ...values,
              precoFinalFob: precoFinalFob,
              precoFinalCif: precoFinalCif,
              precoRegraFob: precoCentroRepli.valorPrecoFOB,
              precoRegraCif: precoCentroRepli.valorPrecoCIF,
              produtoId: produtoSelecionado,
              grupoProdutoId: optProdutoReplicacao.grupoMaterialId
            },
            optProdutoReplicacao,
            filial,
            true);
          }
        });
      });
    }
  };

  const clickProposta = (name, resetValue = true) => {
    formikRef.current.setFieldValue("condicao.faixa", false);
    formikRef.current.setFieldValue("condicao.manter", false);
    formikRef.current.setFieldValue("condicao.especial", false);
    formikRef.current.setFieldValue("condicao." + name, true);
    formikRef.current.setFieldValue("tipoCondicaoId", getTipoCondicaoIdByProposta(name));

    if ((name == "faixa" && resetValue) || name == "manter" || (name == "especial" && resetValue)) {
      setDescontoCif(0);
      setDescontoFob(0);
    }

    if (resetValue) {
      if (name == "especial") {
        setShowOverlay({ fob: true, cif: true });

        if(descontoCif || descontoFob !== 0) {
          setDescontoFob(0);
          setDescontoCif(0);
          setPrecoFinalFob(0);
          setPrecoFinalCif(0);
        }

        formikRef.current?.setFieldValue("grupoProdutoReplicacaoBool", false);
        formikRef.current?.setFieldValue("subGrupoMaterailReplicacaoBool", false);
        formikRef.current?.setFieldValue("produtoReplicacaoBool", false);
        formikRef.current?.setFieldValue("grupoCentralizadorReplicacaoBool", false);
      } else {
        setShowOverlay({ fob: false, cif: false });
        onChangePrazoPagamento({ label: '', value: 0 });
        formikRef.current?.setFieldValue("prazoCif", false);
        formikRef.current?.setFieldValue("prazoFob", false);
      }
    }

    setFaixa(name === "faixa");
    setCondicaoEspecial(name === "especial");
    setManterRegra(name === "manter");
  };

  const submitAddProduto = async (values) => {
    const optProduto = (produtos || []).find((opt) => opt.id == values.produtoId);
    const filial = getFilial();

    if (!filial) {
      setIsOpenModalResponse(true);
      return;
    }

    await processaProduto(values, optProduto, filial);
    await processaReplicacao(values);

    removeLocalStorage("produto-simulacao-nova-" + idCliente);
    desfetchProdutosEditSimulacao();
    navigate(`${initialPath}/simuladores/${idCliente}/simulacao`);
  };

  // Effects
  useEffect(() => {
    if (cliente) {
      setMicrorregiaoId(cliente.microrregiaoId);
      setClusterId(cliente.clusterId);
    }
  }, [cliente]);

  useEffect(() => {
    getIndexDBProdutoSimulacao(idCliente);
  }, []);

  useEffect(() => {
    if (Object.keys(produtoSimulacao).length > 0 || Object.keys(simulacaoProduto).length > 0) {
      const simulacao = Object.keys(simulacaoProduto).length > 0 ? simulacaoProduto : produtoSimulacao;

      SetSelectProduto(simulacao.produtoId);
      SetSelectGrupoProduto(simulacao.grupoMaterialId ?? simulacao.grupoProdutoId);
      SetSelectFilialE(simulacao.filialId);
      setFilialId(simulacao.filialId);
      setSelectPrazoPagamento(simulacao.prazoPagamentoId);

      if (Object.keys(simulacao).length > 3) {
        setPrecoRegraFob(simulacao.precoRegra.fob);
        setPrecoRegraCif(simulacao.precoRegra.cif);
        setPrecoFinalFob(simulacao.precoFinal.fob);
        setPrecoFinalCif(simulacao.precoFinal.cif);
        setDescontoFob(simulacao.desconto.fob);
        setDescontoCif(simulacao.desconto.cif);

        if (simulacao.prazoPagamento && simulacao.prazoPagamentoId)
          onChangePrazoPagamento({ label: simulacao.prazoPagamento, value: simulacao.prazoPagamentoId });

        if (simulacao.enviaPrazoCif) {
          formikRef.current?.setFieldValue("prazoCif", true);
        }

        if (simulacao.enviaPrazoFob) {
          formikRef.current?.setFieldValue("prazoFob", true);
        }

        const type = getPropostaFromSimulacao(simulacao);

        clickProposta(type, false);
      }
    }
  }, [produtoSimulacao, optionProdutos, simulacaoProduto]);

  useEffect(() => {
    if (Object.keys(produtoSimulacao).length > 0 || Object.keys(simulacaoProduto).length > 0) {
      const simulacao = Object.keys(simulacaoProduto).length > 0 ? simulacaoProduto : produtoSimulacao;
      SetSelectProduto(simulacao.produtoId);
      SetSelectGrupoProduto(simulacao.grupoMaterialId || simulacao.grupoProdutoId);
      SetSelectFilialE(simulacao.filialId);
      setInitialReplicacoes(simulacao);
    }
  }, [optionGruposProduto, optionReplicacaoProdutos, optionGruposProdutoReplicacao, optionGruposCentralizadores, optionSubGrupoMateriais]);

  useEffect(() => {
    if (precoRegra) {
      setPrecoRegraFob(precoRegra?.valorPrecoFOB);
      setPrecoRegraCif(precoRegra?.valorPrecoCIF);
      setPrecoFinalFob(precoRegra?.valorPrecoFOB);
      setPrecoFinalCif(precoRegra?.valorPrecoCIF);
    }
  }, [precoRegra]);
  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validateOnBlur={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        values.descontoFob = showOverlay.fob ? 0 : descontoFob;
        values.descontoCif = showOverlay.cif ? 0 : descontoCif;
        values.precoFinalFob = showOverlay.fob ? precoRegraFob : precoFinalFob;
        values.precoFinalCif = showOverlay.cif ? precoRegraCif : precoFinalCif;
        values.precoRegraFob = precoRegraFob;
        values.precoRegraCif = precoRegraCif;
        const propostaSelecionada = manterRegra ? "manter" : (faixa ? "faixa" : "especial");
        values.tipoCondicaoId = getTipoCondicaoIdByProposta(propostaSelecionada) ?? values.tipoCondicaoId;
        submitAddProduto(values);
      }}
    >
      {({ errors, touched, values, isSubmitting }) => (
        <Form id="formProduct">
          <ProductSelectionSection
            optionFiliaisE={optionFiliaisE}
            onChangeFilial={onChangeFilial}
            filialSelectE={filialSelectE}
            optionGruposProduto={optionGruposProduto}
            onChangeGrupoProduto={onChangeGrupoProduto}
            grupoProdutoSelect={grupoProdutoSelect}
            optionProdutos={optionProdutos}
            onChangeProduto={onChangeProduto}
            produtoSelect={produtoSelect}
            errors={errors}
            touched={touched}
          />

          <ProposalTypeSection
            manterRegra={manterRegra}
            faixa={faixa}
            condicaoEspecial={condicaoEspecial}
            clickProposta={clickProposta}
            errors={errors}
            touched={touched}
          />

          <div className="containerForm container bg-white p-7 rounded-lg mt-4 relative">
            <div className="flex justify-between py-3">
              <h2 className="text-2xl font-bold title pb-6">Negociação</h2>
            </div>
            <div className="flex justify-between items-center concorrente proposta gap-x-4 mt-4">
              <div className="container mx-auto mt-4 p-4">
                <div className="overflow-x-auto table-simulators">
                  <table className="w-full bg-white rounded-lg">
                    <thead>
                      <tr>
                        <th className="p-2 sm:p-4 bg-header text-white">Preços</th>
                        <th className="p-2 sm:p-4 bg-header text-white">FOB</th>
                        <th className="p-2 sm:p-4 bg-header text-white">CIF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="bg-row1">
                        <td className="p-2 sm:p-4">Preço Regra (R$/sc)</td>
                        <td className="p-2 sm:p-4">
                          <span className="block text-center">{money(precoRegraFob ?? 0)}</span>
                        </td>
                        <td className="p-2 sm:p-4">
                          <span className="block text-center">{money(precoRegraCif ?? 0)}</span>
                        </td>
                      </tr>
                      {!manterRegra && (
                        <>
                          {faixa && (
                            <>
                              <NegotiationTableRow label="Desconto Negociado" colSpan={2}>
                                <PercentageInput
                                  type={"default"}
                                  value={`${descontoFob}`}
                                  inputName="descontoFobCif"
                                  diff={true}
                                  input={descontoFob}
                                  min={-100}
                                  setInput={(e) => {
                                    setDescontoFob(e);
                                    setDescontoCif(e);
                                  }}
                                  inputEditable
                                />
                              </NegotiationTableRow>
                              <tr className="bg-row3">
                                <td className="p-2 sm:p-4 w-1/3">Preço c/ Desconto (R$/sc)</td>
                                <td className="p-2 sm:p-4 w-1/3">
                                  <span className="block text-center">{money(precoFinalFob)}</span>
                                </td>
                                <td className="p-2 sm:p-4 w-1/3">
                                  <span className="block text-center">{money(precoFinalCif)}</span>
                                </td>
                              </tr>
                            </>
                          )}

                          {condicaoEspecial && (
                            <>
                              <NegotiationTableRow label="Desconto Negociado">
                                <PercentageSpc
                                  value={`${descontoFob}`}
                                  inputName="descontoFob"
                                  input={descontoFob}
                                  setInput={setDescontoFob}
                                  center={true}
                                  onFocus={() => {
                                    setIsEditingDesconto(true);
                                    setIsEditingPrecoFinal(false);
                                  }}
                                  onBlur={() => {
                                    setIsEditingDesconto(false);
                                  }}
                                />
                                <PercentageSpc
                                  value={`${descontoCif}`}
                                  inputName="descontoCif"
                                  input={descontoCif}
                                  setInput={setDescontoCif}
                                  center={true}
                                  onFocus={() => {
                                    setIsEditingDesconto(true);
                                    setIsEditingPrecoFinal(false);
                                  }}
                                  onBlur={() => {
                                    setIsEditingDesconto(false);
                                  }}
                                />
                              </NegotiationTableRow>
                              <tr className="bg-row3">
                                <td className="p-2 sm:p-4 w-1/3">Preço c/ Desconto (R$/sc)</td>
                                <PriceCell
                                  type="fob"
                                  precoFinal={precoFinalFob}
                                  setPrecoFinal={setPrecoFinalFob}
                                  desconto={descontoFob}
                                  setDesconto={setDescontoFob}
                                  showOverlay={showOverlay}
                                  setShowOverlay={setShowOverlay}
                                  condicaoEspecial={condicaoEspecial}
                                  setIsEditingDesconto={setIsEditingDesconto}
                                  setIsEditingPrecoFinal={setIsEditingPrecoFinal}
                                />
                                <PriceCell
                                  type="cif"
                                  precoFinal={precoFinalCif}
                                  setPrecoFinal={setPrecoFinalCif}
                                  desconto={descontoCif}
                                  setDesconto={setDescontoCif}
                                  showOverlay={showOverlay}
                                  setShowOverlay={setShowOverlay}
                                  condicaoEspecial={condicaoEspecial}
                                  setIsEditingDesconto={setIsEditingDesconto}
                                  setIsEditingPrecoFinal={setIsEditingPrecoFinal}
                                />
                              </tr>
                            </>
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>

                {condicaoEspecial && (
                  <div>
                    <div className="bg-primaria rounded-tr-lg rounded-tl-lg mt-10">
                      <p className="p-[16px] bg-header text-white font-bold">Prazo de Pagamento</p>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-x-5 p-4 items-center">
                      <p className="whitespace-nowrap">Prazo Diferenciado</p>
                      <div className="w-[100%] mt-4">
                        <Select
                          name="prazoPagamentoId"
                          label=""
                          placeholder=""
                          options={optionPrazosPagamento}
                          noOptionsMessage="Prazo não encontrado"
                          onChange={onChangePrazoPagamento}
                          errors={errors.prazoPagamentoId}
                          touched={touched.prazoPagamentoId}
                          {...prazoPagamentoSelect}
                        />
                      </div>

                      <div className="flex gap-x-4">
                        <div className="flex items-center gap-x-2">
                          <label className="flex items-center space-x-2">
                            <Checkbox
                              name="prazoCif"
                              isChecked={values.prazoCif}
                              onChange={(e) => handleChangeEnviaPrazo(e, "cif")}
                            />
                            <span className="text-lg font-bold">CIF</span>
                          </label>
                        </div>
                        <div className="flex items-center gap-x-2">
                          <label className="flex items-center space-x-2">
                            <Checkbox
                              name="prazoFob"
                              isChecked={values.prazoFob}
                              onChange={(e) => handleChangeEnviaPrazo(e, "fob")}
                            />
                            <span className="text-lg font-bold">FOB</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Seções de replicação - mantidas como no código original por brevidade */}
          {faixa && !loading && (
            <div className="containerForm container bg-white p-7 rounded-lg mt-4 relative">
              <div className="sm:flex justify-between py-3">
                <h2 className="text-2xl font-bold title pb-6">Replicar Negociação</h2>
              </div>
              <div>
                <div className="flex flex-col md:flex-row gap-4 justify-between w-full">
                  <label className="flex items-center space-x-2">
                    <Field
                      type="checkbox"
                      name="grupoProdutoReplicacaoBool"
                      disabled={values.subGrupoMaterailReplicacaoBool || values.produtoReplicacaoBool}
                      className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                    />
                    <span className="font-bold text-lg">Grupo de produtos</span>
                  </label>
                  <div className="md:w-[70%] w-full">
                    <Select
                      name="grupoProdutoReplicacaoId"
                      label=""
                      placeholder=""
                      options={optionGruposProdutoReplicacao}
                      noOptionsMessage="Grupo de produto não encontrado"
                      onChange={onChangeGrupoProdutoReplicacao}
                      errors={errors.grupoProdutoReplicacaoId}
                      touched={touched.grupoProdutoReplicacaoId}
                      isDisabled={!values.grupoProdutoReplicacaoBool}
                      {...grupoProdutoReplicacaoSelect}
                    />
                  </div>
                </div>
                {/* Outras seções de replicação... */}
              </div>
            </div>
          )}

          {condicaoEspecial && !loading && (
            <div className="containerForm container bg-white p-7 rounded-lg mt-4 relative">
              <div className="sm:flex justify-between py-3">
                <h2 className="text-2xl font-bold title pb-6">Replicar Negociação</h2>
              </div>
              <div>
                <div className="flex flex-col md:flex-row gap-4 justify-between w-full">
                  <label className="flex items-center space-x-2">
                    <Field
                      type="checkbox"
                      name="centroReplicacaoBool"
                      className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                    />
                    <span className="font-bold text-lg">Centro</span>
                  </label>
                  <div className="md:w-[70%] w-full">
                    <Multiselect
                      name="filialReplicacaoId"
                      options={optionFiliaisReplicacao}
                      selectedValues={initialValues.centros}
                      placeholder=""
                      showArrow
                      customArrow={true}
                      displayValue="label"
                      disable={!values.centroReplicacaoBool}
                      emptyRecordMsg="Centro não encontrado"
                      onRemove={handleFilialReplicacaoMulti}
                      onSelect={handleFilialReplicacaoMulti}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {loading && (
            <div className="py-6 flex justify-center">
              <Spinner />
            </div>
          )}

          <ValidateFormModal errors={errors} isSubmiting={isSubmitting} />

          <ModalCreateProduct
            isOpen={isModalOpenPrice}
            onClose={closeModalPrice}
            title="Aviso!"
            sub={
              <>
                <p className="font-bold max-w-[400px]">Esta condição especial irá sobrepor a fixa</p>
                <p className="font-bold center mt-4">Deseja continuar ?</p>
              </>
            }
            buttonOne="Não"
            buttonTwo="Sim"
            linkOne={null}
            linkTwo={null}
          />

          <ModalResponse
            isOpen={isOpenModalResponse}
            status="warning"
            message="Não foi possível definir o centro/filial dessa simulação"
            submessage={<>Houve um erro ao definir o centro/filial da atual simulação, <br />tente <b>sincronizar os dados e recarregar a página</b>. <br />Caso o erro persista, contate o suporte.</>}
            closeModal={() => setIsOpenModalResponse(false)}
          />
        </Form>
      )}
    </Formik>
  );
};

export default EditarProdutoFormulario;